import React, { useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { buildBaseOption, buildChartTheme } from './chartTheme';

const DEFAULT_COLOR_KEYS = ['running', 'autonomous', 'queued'];

function LineChart({
  series = [],
  labels = [],
  height = 220,
  area = false,
  colorKeys = DEFAULT_COLOR_KEYS
}) {
  const wrapperRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const node = wrapperRef.current;
    const instance = chartRef.current?.getEchartsInstance?.();

    if (!node || !instance || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(() => instance.resize());
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const theme = buildChartTheme();
  const option = buildBaseOption(theme);

  option.xAxis.data = labels;
  option.series = series.map((entry, index) => {
    const color = theme.colors[colorKeys[index % colorKeys.length]] || theme.colors.running;

    return {
      name: entry.name,
      type: 'line',
      smooth: true,
      symbol: 'none',
      data: entry.data,
      itemStyle: { color },
      lineStyle: { color, width: 2 },
      areaStyle: area ? { color, opacity: 0.12 } : undefined
    };
  });

  return (
    <div className="chart-wrapper" ref={wrapperRef} style={{ height }}>
      <ReactECharts
        ref={chartRef}
        option={option}
        style={{ height: '100%', width: '100%' }}
        notMerge
        lazyUpdate
      />
    </div>
  );
}

export default LineChart;
